module.exports = __webpack_public_path__ + "img/20220219_072931.e575a079.jpg";